import { render, staticRenderFns } from "./customerVip.vue?vue&type=template&id=b5f07ef4"
import script from "./customerVip.vue?vue&type=script&lang=js"
export * from "./customerVip.vue?vue&type=script&lang=js"
import style0 from "./customerVip.vue?vue&type=style&index=0&id=b5f07ef4&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports